import { useInfiniteQuery, useQuery } from "@tanstack/react-query";
import {
  getArticles,
  getArticleApi,
  GetArticlesParams,
  IArticle,
} from "@src/apis/articleApis";
import { QUERY_KEYS } from "./queryKeys";
import { AxiosResponse } from "axios";
import { ApiResponse } from "@src/types/httpApi";

export const useInfiniteArticles = (
  params: GetArticlesParams,
  options?: any
) => {
  return useInfiniteQuery({
    queryKey: [QUERY_KEYS.GET_ARTICLES, params],
    queryFn: ({ pageParam = 1 }: { pageParam?: number }) =>
      getArticles({
        ...params,
        page: pageParam,
        pageSize: params.pageSize || 25,
      }),
    getNextPageParam: (
      lastPage: AxiosResponse<ApiResponse<IArticle[]>> | undefined
    ): number | undefined => {
      if (!lastPage || !lastPage?.data?.meta?.pagination) {
        return undefined;
      }
      try {
        const { page: currentPage, pageCount: totalPages } =
          lastPage.data.meta.pagination;
        return currentPage < totalPages ? currentPage + 1 : undefined;
      } catch {
        return undefined;
      }
    },
    gcTime: 5000,
    staleTime: 1000 * 60 * 5, // 5 minutes
    enabled: !!params.curatorId,
    ...options,
  });
};

export const useArticles = (params: GetArticlesParams, options?: any) => {
  return useQuery({
    queryKey: [QUERY_KEYS.GET_ARTICLES, params],
    queryFn: () => getArticles(params),
    gcTime: 5000,
    staleTime: 1000 * 60 * 5, // 5 minutes
    enabled: !!params.curatorId,
    ...options,
  });
};

export const useArticle = (articleId: string, options?: any) => {
  return useQuery({
    queryKey: [QUERY_KEYS.GET_ARTICLES, "single", articleId],
    queryFn: () => getArticleApi(articleId),
    gcTime: 5000,
    staleTime: 1000 * 60 * 5,
    enabled: !!articleId,
    ...options,
  });
};
